export class RelationConditionResult {
    constructor(relationType, result) {
        this.relationType = relationType;
        this.result = result;
    }
}
